import classNames from 'classnames';
import { memo } from 'react';

import { PlusIcon } from '@air/design-icons';

import { SELECT_CREATE_OPTION } from '~/components/Select/shared/testIDs';

type SelectCreateOptionProps = {
  onClick: () => void;
  value: string;
  hideSpacer: boolean;
  createVerb?: string;
};

export const SelectCreateOption = memo(
  ({ onClick, hideSpacer, value, createVerb = 'Create' }: SelectCreateOptionProps) => {
    return (
      // biome-ignore lint/a11y/useKeyWithClickEvents: Enter in the select input creates the option when pressEnterToAdd is set. PLA-1724 — pre-existing debt, not introduced by the icon migration
      <li
        className={classNames(
          'w-full',
          hideSpacer ? 'mt-0 border-t-none' : 'mt-2 border-t ads:border-t-ads-gray-5 border-t-gray-5',
        )}
        data-testid={SELECT_CREATE_OPTION}
        onClick={onClick}
      >
        <div className={classNames('w-full', hideSpacer ? 'mt-0' : 'mt-2')}>
          <div
            className={classNames(
              'flex w-full cursor-pointer items-center justify-start',
              hideSpacer ? 'mt-0' : 'mt-3',
            )}
          >
            <PlusIcon className="ads:text-icon-default text-gray-11" size="sm" />
            <div className="ml-1.5 font-medium ads:text-secondary text-14 text-gray-11">{`${createVerb} "${value}"?`}</div>
          </div>
        </div>
      </li>
    );
  },
);

SelectCreateOption.displayName = 'SelectCreateOption';
